	<template>
  <div @click.stop.prevent="handleClick">
    <div class="row">
      <div class="col-12 col-xs-12 col-sm-9">
        <h3 class="txt--xl">
          {{ title }}
        </h3>
      </div>
      <div class="col-12 col-xs-12 col-sm-3">
        <button class="calculator__switcher" @click="switchLayout()">
          <span v-if="switchType == false">switch to st, lbs</span>
          <span v-if="switchType == true">switch to kg</span>
        </button>
      </div>
    </div>
    <div class="row" v-if="description != ''">
      <div class="col-12 col-xs-12">
        <div v-html="description"></div>
      </div>
    </div>
    <div class="row" v-if="weightNotValid">
      <div class="col-12 col-xs-12">
        <span class="danger-text"> Are you sure? </span>
      </div>
    </div>
    <div class="row" :class="[{ hide: switchType == true }]">
      <div class="col-12 col-xs-6 col-sm-4">
        <label class="calculator__label" :for="id + '-kg'">Kilograms</label>
        <InputNumberElement
          v-model="kg"
          :decimal="true"
          :id="id + '-kg'"
          :classes="{
            'calculator__input--error': weightNotValid || errorCheck,
          }"
          :step="0.05"
          label="Kilograms"
          min="0"
          @blur="kgToStPo()"
          @change="eventChange()"
        />
      </div>
    </div>
    <div class="row" :class="[{ hide: switchType == false }]">
      <div class="col-12 col-xs-6 col-sm-4">
        <label class="calculator__label" :for="id + '-st'">Stone</label>
        <InputNumberElement
          v-model="st"
          :decimal="false"
          :id="id + '-st'"
          :classes="{
            'calculator__input--error': weightNotValid || errorCheck,
          }"
          :step="1"
          label="Stone"
          min="0"
          @blur="stPoToKg()"
          @change="eventChange()"
        />
      </div>
      <div class="col-12 col-xs-6 col-sm-4">
        <label class="calculator__label" :for="id + '-lb'"
          >Pounds (max 13)</label
        >
        <InputNumberElement
          v-model="lb"
          :decimal="false"
          :id="id + '-lb'"
          :classes="{
            'calculator__input--error': weightNotValid || errorCheck,
          }"
          :step="1"
          label="Pounds"
          min="0"
          max="13"
          @blur="stPoToKg()"
          @change="eventChange()"
        />
      </div>
    </div>
    <div class="row" v-if="errorWeight">
      <div class="col-12 col-xs-12">
        <p class="danger-text">
          <strong
            >The weight loss is 2st 6lb (15.4kg) or more. Are you sure that the
            current and previous weights are correct?</strong
          >
        </p>
      </div>
    </div>
    <hr class="mb-2 mb--2" />
  </div>
</template>

	<script>
import InputNumberElement from "@/components/inputs/InputNumberElement";
export default {
  name: "InputWeight",
  components: {
    InputNumberElement,
  },
  props: {
    title: String,
    description: String,
    id: String,
    errorCheck: Boolean,
    errorWeight: Boolean,
  },
  data() {
    return this.initialState();
  },
  methods: {
    handleClick(e) {
      if (e.target.matches("a")) {
        let url = e.target.href;
        let target = e.target.target == "_blank" ? "_blank" : "_self";
        let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
        var isnativeapp = document.getElementById("isnativeapp");
        if (isnativeapp === undefined || isnativeapp === null) {
          window.open(url, target);
        } else {
          if (target == "_blank") {
            let data = { title: "", nodeid: dataId, href: url, target: target };
            window.Native("dataCallback", data);
          }
        }
      }
    },

    convertDecimals() {
      console.log("TEST on blur");
    },

    initialState() {
      return {
        switchType: false,
        kg: null,
        st: null,
        lb: null,
        previousKg: null,
        weightMin: 35,
        weightMax: 135,
        weightNotValid: false,
      };
    },

    reset() {
      Object.assign(this.$data, this.initialState());
    },

    eventChange() {
      this.$emit("inputChange");
    },

    stPoToKg() {
      this.$emit("inputPress");
      setTimeout(() => {
        if (this.lb > 13) {
          this.lb = 13;
        } 

        let st = this.st;
        let lb = this.lb;

        this.st = parseFloat(parseFloat(st).toFixed(0));
        this.lb = lb != null ? parseFloat(parseFloat(lb).toFixed(0)) : 0

        let kilograms = parseFloat(parseFloat(this.st).toFixed(0)) / 0.15747 + parseFloat(parseFloat(this.lb).toFixed(0)) / 2.2046;

        this.setStLb(this.st, this.lb);
        this.setKg(kilograms);
        this.checkValue();
      }, 300);
      return;
    },

    kgToStPo() {
      this.$emit("inputPress");
      setTimeout(() => {
        let stone = parseFloat(
          Math.floor(parseFloat(parseFloat(this.kg).toFixed(2)) * 0.157473)
        );
        let pounds = parseFloat(
          Math.round(parseFloat(parseFloat(this.kg).toFixed(2)) * 2.2046) -
            stone * 14
        );
        if (pounds >= 14) {
          pounds = 0;
          stone++;
        }
        this.setKg(this.kg);
        this.setStLb(stone, pounds);
        this.checkValue();
      }, 300);
      return;
    },

    setKg(kilograms) {
      setTimeout(() => {
        this.kg = parseFloat(parseFloat(kilograms).toFixed(2));
      }, 0);
      return;
    },

    setStLb(stone, pounds) {
      setTimeout(() => {
        console.log('current pounds:' + ' ' + pounds);

        this.st = parseFloat(parseFloat(stone).toFixed(0));
        if (this.lb > 13) {
          this.lb = 13;
        } 
        else {
          this.lb = parseFloat(
            pounds != null ? parseFloat(parseFloat(pounds).toFixed(0)) : 0
          );
        }
        if (isNaN(pounds) || pounds == null && this.st > 0) {
          console.log("set pounds to 0 as it's empty or null (1)");
          this.lb = 0;
          console.log('current pounds set:' + ' ' + pounds);
        }
      }, 0);
      return;
    },

    checkValue() {
      setTimeout(() => {
        if (
          (this.kg < this.weightMin || this.kg > this.weightMax) &&
          this.kg != ""
        ) {
          this.weightNotValid = true;
        } else {
          this.weightNotValid = false;
        }
      }, 0);
      return;
    },

    switchLayout() {
      this.switchType = !this.switchType;
    },
  },
};
</script>